export const FOOTER_CONTACT_ID = 'footer-contact';

export function scrollToFooterContact() {
  const el = document.getElementById(FOOTER_CONTACT_ID);
  if (el) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}
